

/* @jsxRuntime classic */
/* @jsx mdx */
/* @jsxFrag React.Fragment */

import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {};
export const contentTitle = 'oneOf';
export const metadata = {
  "unversionedId": "subschemas/combiners-oneof",
  "id": "subschemas/combiners-oneof",
  "title": "oneOf",
  "description": "Enum with titles",
  "source": "@site/docs/subschemas/combiners-oneof.md",
  "sourceDirName": "subschemas",
  "slug": "/subschemas/combiners-oneof",
  "permalink": "/autoviews/docs/subschemas/combiners-oneof",
  "draft": false,
  "editUrl": "https://github.com/wix-incubator/autoviews/tree/master/website/docs/subschemas/combiners-oneof.md",
  "tags": [],
  "version": "current",
  "frontMatter": {},
  "sidebar": "mySidebar",
  "previous": {
    "title": "if/then/else",
    "permalink": "/autoviews/docs/subschemas/conditions"
  },
  "next": {
    "title": "$ref",
    "permalink": "/autoviews/docs/subschemas/combiners-ref"
  }
};
export const assets = {

};

import {Demo} from '@site/src/components';
import * as insideObjectFiles from '../../src/examples/subschemas/oneof/inside-object';
import * as enumDemo from '@site/src/examples/subschemas/oneof/enum';
export const toc = [{
  value: 'Enum with titles',
  id: 'enum-with-titles',
  level: 2
}, {
  value: 'OneOf inside object',
  id: 'oneof-inside-object',
  level: 2
}];
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const CustomOneOfComponent = makeShortcode("CustomOneOfComponent");
const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "oneof"
    }}>{`oneOf`}</h1>


    <h2 {...{
      "id": "enum-with-titles"
    }}>{`Enum with titles`}</h2>
    <p>{`Where dropdown render is needed, `}<inlineCode parentName="p">{`enum`}</inlineCode>{` is the first thing that come to mind. Unfortunately, it's lack of titles functionality (enumNames `}<a parentName="p" {...{
        "href": "https://github.com/rjsf-team/react-jsonschema-form/issues/532"
      }}>{`proposal`}</a>{` wasn't accepted).
In this case, `}<inlineCode parentName="p">{`oneOf`}</inlineCode>{` + `}<inlineCode parentName="p">{`const`}</inlineCode>{` is here to the rescue.`}</p>
    <admonition {...{
      "type": "note"
    }}><p parentName="admonition">{`In this example, schema's node with `}<inlineCode parentName="p">{`oneOf`}</inlineCode>{` doesn't contain `}<inlineCode parentName="p">{`type`}</inlineCode>{` keyword, so repo's `}<inlineCode parentName="p">{`getNodeType`}</inlineCode>{` must return `}<inlineCode parentName="p">{`oneOf`}</inlineCode>{` type in order to render registered component automatically.
Alternatively, `}<inlineCode parentName="p">{`<RepositoryComponentByType />`}</inlineCode>{` could be used to render `}<inlineCode parentName="p">{`oneOf`}</inlineCode>{` component manually inside object component.`}</p></admonition>
    <Demo {...enumDemo} mdxType="Demo" />
    <h2 {...{
      "id": "oneof-inside-object"
    }}>{`OneOf inside object`}</h2>
    <p>{`Common example with form, where only one field is required (`}<inlineCode parentName="p">{`homePhone`}</inlineCode>{` or `}<inlineCode parentName="p">{`mobilePhone`}</inlineCode>{`).`}</p>
    <p>{`This examples have two different oneOf components, one the same as in previous example, and second one, which is rendered manually as part of object type.`}</p>
    <admonition {...{
      "type": "note"
    }}><p parentName="admonition">{`Note, here `}<CustomOneOfComponent mdxType="CustomOneOfComponent" />{` contains some JSON Schema generation, which could passed to AutoView to automatically render dropdown with registered in repo component.`}</p></admonition>
    <Demo {...insideObjectFiles} mdxType="Demo" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
